import { Store } from "pullstate";

export const databaseStore = new Store({
	resultsData: {},
	teamsData: {},
	isLoading: false
});
